setInterval(() => {
  //d8b1c2.myshopify.com

  const citySelect = document.querySelector('select[data-type="city_country_field"]');
  const provinceSelect = document.querySelector('select[data-type="province_country_field"]');
  const citiesToHideCodButton = ["CABURGA","CHOROICO","MELIPEUCO","COLICO","CURACALCO","LAS HORTENCIAS","LUMACO","SAN PATRICIO","TOLTEN","VILLA BOLDO","CARAMPANGUE","LOS HORCONES","RAMADILLAS","COLIUMO","DICHATO","SAN ROSENDO","HORCON IV","LA ESTRELLA","PUMANQUE","RAPEL","PUERTO OCTAY","PUYEHUE","SAN PABLO","CURACO DE VELEZ","COCHAMO","RINIHUE","CALAFQUEN","CHAUQUEN","COZ COZ","ROBLE HUACHO","ALHUE","CHAMPA","POLPAICO","POMAIRE","LAS TRANCAS","LOS TILOS","MONTE AGUILA","NINHUE","PEMUCO","PORTEZUELO","QUIRIQUINA","TREHUACO","IQUIQUE","ALTO HOSPICIO","HUARA","La Hauyca","La Tirana","POZO ALMONTE","TUNQUEN","CHILCAS","PORTILLO","RINCONADA DE GUZMAN","SALADILLO"];
  const citiesToHidePrepaidButton = [];
  /*const citiesToHidePrepaidButton = [];*/

  if (citySelect && citySelect.value.trim() !== "" && provinceSelect) { 
    if (citiesToHideCodButton.includes(citySelect.value) && provinceSelect.value != 0) {
      document.querySelector("._rsi-build-block-submit-button").style.display = "none"; 
    } else {
      document.querySelector("._rsi-build-block-submit-button").style.display = "block";
    }
  }

if (citySelect && citySelect.value.trim() !== "" && provinceSelect) { 
    if (citiesToHidePrepaidButton.includes(citySelect.value) && provinceSelect.value != 0) {
      document.querySelector("._rsi-buy-now-custom-additionals-button").style.display = "none"; 
    } else {
      document.querySelector("._rsi-buy-now-custom-additionals-button").style.display = "block";
    }
  }


}, 500);

